import React from 'react';
import { Chip, TableRow, TableCell } from '@mui/material';
import { useTranslation } from "react-i18next";

function GeneListCounter({ items }) {
  const activeCount = items.filter(item => item.active).length;
  const inactiveCount = items.length - activeCount;
  const { t } = useTranslation();
  
  return (
    <TableRow>
      <TableCell>
        <Chip label={`${t("Active")}: ${activeCount}`} color="success" size="small" />
      </TableCell>
      <TableCell>
        <Chip label={`${t("Inactive")}: ${inactiveCount}`} color="error" size="small"  />
      </TableCell>
    </TableRow>
  );
}

export default GeneListCounter;